import request from './request'

export function curMonthNoFzCardUsers(data) {
    return request({
        url: '/api/case/curMonthNoFzCardUsers',
        method: 'get',
        params: data
    })
}

export function unacceptedUsers(data) {
    return request({
        url: '/api/case/unacceptedUsers',
        method: 'get',
        params: data
    })
}

export function unReplyUsers(data) {
    return request({
        url: '/api/case/unReplyUsers',
        method: 'get',
        params: data
    })
}
export function getDoctorListData(url,data) {
    return request({
        url: url,
        method: 'get',
        params: data
    })
}
export function getPatientListData(url,data) {
    return request({
        url: url,
        method: 'get',
        params: data
    })
}
